<template lang="pug">
  span(class="sage-errores-cell") {{ formattedErrors }}
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'sageErroresTemplate'
})
export default class SageErroresTemplateComponent extends Vue {
  data: any

  get formattedErrors(): string {
    const raw = this.data?.errores
    if (!raw) {
      return ''
    }
    let parsed: unknown = raw
    if (typeof raw === 'string') {
      try {
        parsed = JSON.parse(raw)
      } catch {
        return raw
      }
    }
    if (Array.isArray(parsed)) {
      return parsed.join('\n')
    }
    return String(parsed)
  }
}
</script>

<style lang="scss" scoped>
.sage-errores-cell {
  white-space: pre-line;
}
</style>
